import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DutyHolderDetail } from "../../Types/DutyHolderDetails/DutyHolderDetailsTypes";
import { getDutyHolderDetailsByFolderId } from "../../Thunks/BuildingInspectorThunks";

interface DutyHolderSliceState {
  loader: boolean; // for refres pages and inital loadings
  dutyHolderList: DutyHolderDetail[];
  errorDisplay: string | null;
}

// set inital valus
const initialState: DutyHolderSliceState = {
  loader: false,
  dutyHolderList: [],
  errorDisplay: '',
}

// set state valu for api response
const dutyHolderSlice = createSlice({
  name: 'dutyHolderSlice',
  initialState,
  reducers: {
  },
  extraReducers(builder) {
    builder.addCase(getDutyHolderDetailsByFolderId.rejected, (state, action) => {
      state.loader = false;
      state.errorDisplay = action.error.message!;
    })
      .addCase(getDutyHolderDetailsByFolderId.pending, state => {
        state.loader = true;
        state.errorDisplay = null;
      })
      .addCase(getDutyHolderDetailsByFolderId.fulfilled, (state, action: PayloadAction<DutyHolderDetail[]>) => {
        state.loader = false;
        state.dutyHolderList = action.payload;
      })
  }
})

export const { } = dutyHolderSlice.actions
export default dutyHolderSlice.reducer
